import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Quote extends Component {
  render () {
    let imageEl

    const { image, children, source, alt, color = 'lime' } = this.props

    if (image) {
      imageEl = <img className="quote__image" src={image} alt={alt} />
    }

    return (
      <blockquote className={`quote quote--${color}`}>
        <div className="quote__content">
          {imageEl}
          <div className="quote__copy">
            <p className="quote__text">{children}</p>
            {source ? <span className="quote__name">{source}</span> : null}
          </div>
        </div>
      </blockquote>
    )
  }
}

Quote.propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string,
  source: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.oneOf(['blue', 'yellow', 'pink', 'lime'])
}

export default Quote;
